const styles = theme => ({
  navIconHide: {
    marginLeft:-7,
    [theme.breakpoints.up('sm')]: {
      marginLeft:-7,
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/ApplicationBar/components/ToolBar/components/NavIcon/styles.js